import papaparse from 'papaparse';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { isEmpty, isNullish } from 'remeda';

import type { CsvData } from '../types.ts';

export function useLoadCsvFile() {
  const history = useHistory();
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [csvData, setCsvData] = useState<CsvData>();

  useEffect(() => {
    if (isNullish(csvData)) fileInputRef.current?.click();
  }, [csvData]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files: uploadedFiles } = event.target;

    if (isNullish(uploadedFiles) || isEmpty(uploadedFiles)) history.goBack();
    const file = uploadedFiles?.[0];
    if (isNullish(file)) {
      history.goBack();
      return;
    }

    const reader = new FileReader();

    reader.onload = (readerEvent: ProgressEvent<FileReader>) => {
      const data = readerEvent.target?.result as string;
      const parsedData = papaparse.parse(data, {
        skipEmptyLines: 'greedy',
      });

      setCsvData(parsedData.data as any);
    };

    reader.readAsText(file, 'UTF-8');
  };

  const inputElement = (
    <input
      type="file"
      ref={fileInputRef}
      style={{ display: 'none' }}
      accept="text/csv"
      onChange={handleFileChange}
    />
  );

  return { inputElement, csvData, setCsvData };
}
